/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface HttpResponseDto {
  /**
   * A message providing additional context for the response
   * @example "Password successfully changed"
   */
  message?: string;
  /**
   * List of errors or a single error message
   * @example ["Invalid input data","Password too short"]
   */
  errors?: object;
  /**
   * High-level description of the error
   * @example "Bad Request"
   */
  error?: string;
  /**
   * A human-readable status of the response
   * @example "success"
   */
  status?: string;
  /**
   * HTTP status code of the response
   * @example 400
   */
  statusCode?: number;
}

export interface ValidateTokenDto {
  /**
   * JWT token to validate
   * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
   */
  token: string;
}

export interface ImageMetadataDto {
  /**
   * URL of the image
   * @example "https://example.com/avatars/user-123.avif"
   */
  url: string;
  /**
   * Width of the image in pixels
   * @example 500
   */
  width: number;
  /**
   * Height of the image in pixels
   * @example 500
   */
  height: number;
  /**
   * Size of the image in bytes
   * @example 102400
   */
  size: number;
}

export interface AvatarUploadResponseDto {
  /**
   * Image UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  imageUUID: string;
  /** Full size image metadata */
  fullSize: ImageMetadataDto;
  /** Thumbnail image metadata */
  thumbnail: ImageMetadataDto;
}

export interface UserDto {
  /**
   * The unique identifier of the user
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  userUUID: string;
  /**
   * The first name of the user
   * @example "John"
   */
  firstName?: string;
  /**
   * The last name of the user
   * @example "Doe"
   */
  lastName?: string;
  /**
   * The email address of the user
   * @example "johndoe@example.com"
   */
  email: string;
  /**
   * The phone number of the user
   * @example "+1234567890"
   */
  phoneNumber?: string;
  /**
   * The role of the user
   * @example "ADMIN"
   */
  role: "TENANT" | "ADMIN" | "OWNER" | "STAFF" | "UNASSIGNED";
  /**
   * The status of the user
   * @example "ACTIVE"
   */
  status: "ACTIVE" | "INACTIVE" | "PENDING" | "SUSPENDED";
  /**
   * The password of the user (hashed)
   * @example "hashed_password_here"
   */
  password?: string;
  /**
   * The birth date of the user
   * @format date-time
   * @example "1990-01-01"
   */
  birthDate?: string;
  /**
   * Indicates whether the user is active
   * @example true
   */
  isActive: boolean;
  /**
   * The date when the user was created
   * @format date-time
   * @example "2023-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * The date when the user was last updated
   * @format date-time
   * @example "2023-01-02T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * The Google profile image URL of the user
   * @example "https://lh3.googleusercontent.com/a/example"
   */
  imageGoogleUrl?: string;
  /**
   * The avatar data of the user
   * @example {"url":"https://example.com/avatar.jpg","alt":"User avatar"}
   */
  avatarData?: AvatarUploadResponseDto;
  /**
   * The Google ID of the user
   * @example "123456789"
   */
  googleId?: string;
  /**
   * Indicates if the user registered through a social provider
   * @example true
   */
  socialProvider?: boolean;
  /**
   * The name of the social provider used for registration
   * @example "google"
   */
  providerName?: string;
}

export interface GoogleAuthDto {
  /**
   * Google OAuth access token
   * @example "ya29.a0AfB_byC3Mz..."
   */
  accessToken: string;
}

export interface AccessTokenDto {
  /**
   * JWT access token for user authentication
   * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxMjM0NTY3ODkwIiwiaWF0IjoxNjM1MjY2OTkwLCJleHAiOjE2MzUyNzA1OTB9.-abcdef123456"
   */
  accessToken: string;
}

export interface CreateAuthDto {
  /**
   * Email address of the user
   * @example "admin@example.com"
   */
  email: string;
  /**
   * Password of the user
   * @example "admin123"
   */
  password: string;
}

export interface UpdatePasswordAuthDto {
  /**
   * Current password of the user
   * @example "OldPassword123"
   */
  currentPassword: string;
  /**
   * New password to set for the user
   * @example "NewPassword123"
   */
  newPassword: string;
  /**
   * Confirmation of the new password
   * @example "NewPassword123"
   */
  confirmNewPassword: string;
}

export interface AccessTokenResponse {
  /**
   * Access token
   * @example "accessToken"
   */
  accessToken: string;
}

export enum UserRole {
  TENANT = "TENANT",
  ADMIN = "ADMIN",
  OWNER = "OWNER",
  STAFF = "STAFF",
  UNASSIGNED = "UNASSIGNED",
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
  SUSPENDED = "SUSPENDED",
}

export interface PaginatedUserDto {
  content: UserDto[];
  totalElements: number;
  totalPages: number;
  numberOfElements: number;
  size: number;
  page: number;
  last: boolean;
}

export interface UserStatisticsDto {
  totalUsers: number;
  activeUsers: number;
  pendingUsers: number;
  inactiveUsers: number;
}

export type User = object;

export interface UpdateUserDto {
  /**
   * First name of the user
   * @example "John"
   */
  firstName?: string;
  /**
   * Last name of the user
   * @example "Doe"
   */
  lastName?: string;
  /**
   * Email address of the user
   * @example "johndoe@example.com"
   */
  email?: string;
  /**
   * Phone number of the user
   * @example "+1234567890"
   */
  phoneNumber?: string;
  /**
   * Role of the user
   * @example "ADMIN"
   */
  role?: "TENANT" | "ADMIN" | "OWNER" | "STAFF" | "UNASSIGNED";
  /**
   * Status of the user
   * @example "ACTIVE"
   */
  status?: "ACTIVE" | "INACTIVE" | "PENDING" | "SUSPENDED";
  /**
   * Birth date of the user in ISO 8601 format
   * @example "1990-01-01"
   */
  birthDate?: string;
  /** Full avatar data with metadata */
  avatarData?: AvatarUploadResponseDto;
  /**
   * Indicates whether the user is active
   * @example true
   */
  isActive?: boolean;
}

export interface UserNotificationsSettings {
  /**
   * Unique identifier for notification settings
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Phone notifications status
   * @default true
   * @example true
   */
  phoneEnabled: boolean;
  /**
   * Email notifications status
   * @default true
   * @example true
   */
  emailEnabled: boolean;
  /**
   * Push notifications status
   * @default true
   * @example true
   */
  pushEnabled: boolean;
  /** User who owns these notification settings */
  user: User;
  /**
   * User identifier
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  userId: string;
}

export interface UpdateNotificationsSettingsDto {
  /**
   * Enable/disable phone notifications
   * @example true
   */
  phoneEnabled?: boolean;
  /**
   * Enable/disable email notifications
   * @example true
   */
  emailEnabled?: boolean;
  /**
   * Enable/disable push notifications
   * @example true
   */
  pushEnabled?: boolean;
}

export interface UserAuditLog {
  /**
   * Unique identifier of the audit log
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /** User who performed the action */
  user: User;
  /**
   * ID of the user who performed the action
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  userId: string;
  /**
   * Type of action performed
   * @example "UPDATE_PROFILE"
   */
  action:
    | "UPDATE_PROFILE"
    | "DELETE_PROFILE"
    | "CHANGE_PASSWORD"
    | "CHANGE_EMAIL"
    | "CHANGE_PHONE"
    | "UPDATE_NOTIFICATIONS"
    | "UPDATE_SETTINGS"
    | "ACTIVATE_ACCOUNT"
    | "DEACTIVATE_ACCOUNT"
    | "BLOCK_ACCOUNT"
    | "LOGIN"
    | "LOGOUT"
    | "FAILED_LOGIN"
    | "EMAIL_VERIFIED"
    | "PHONE_VERIFIED"
    | "CHANGE_ROLE";
  /**
   * Detailed information about the changes
   * @example {"oldValue":{"name":"John"},"newValue":{"name":"Johnny"},"changedFields":["name"]}
   */
  details: object;
  /**
   * IP address from which the action was performed
   * @example "192.168.1.1"
   */
  ipAddress: string;
  /**
   * User agent information
   * @example "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36"
   */
  userAgent: string;
  /**
   * Timestamp when the action was performed
   * @format date-time
   * @example "2024-02-20T15:30:00.000Z"
   */
  createdAt: string;
}

export interface PaginatedUserAuditLogDto {
  /**
   * Number of elements on the current page
   * @example 10
   */
  numberOfElements: number;
  /**
   * Size of the page (number of elements per page)
   * @example 20
   */
  size: number;
  /**
   * Current page number (starting from 0)
   * @example 0
   */
  page: number;
  /**
   * Total number of elements in all pages
   * @example 100
   */
  totalElements: number;
  /**
   * Total number of pages
   * @example 5
   */
  totalPages: number;
  /**
   * Indicates whether this is the last page
   * @example true
   */
  last: boolean;
  /**
   * Indicates whether this is the first page
   * @example false
   */
  first?: boolean;
  /** Array of audit log items in the current page */
  content: UserAuditLog[];
}

export interface UserSettings {
  /**
   * Унікальний ідентифікатор налаштувань
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * Тема інтерфейсу
   * @default "system"
   * @example "system"
   */
  theme: "light" | "dark" | "system";
  /** Користувач, якому належать налаштування */
  user: User;
  /**
   * Ідентифікатор користувача
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  userId: string;
}

export interface UpdateUserSettingsDto {
  /**
   * Тема інтерфейсу
   * @example "system"
   */
  theme?: "light" | "dark" | "system";
}

export interface SendMailDto {
  context: Record<string, string>;
  /**
   * Whether to check user email notification settings before sending
   * @default false
   */
  checkEmailSettings?: boolean;
  /**
   * Whether to throw an error when notifications are disabled (if false, will skip silently)
   * @default false
   */
  throwErrorOnDisabled?: boolean;
}

export interface SendSmsDto {
  /**
   * Array of phone numbers to send SMS to
   * @example ["+380991234567"]
   */
  recipients: string[];
  /**
   * SMS message text
   * @example "Your verification code is: 123456"
   */
  message: string;
  /**
   * Whether to check user SMS notification settings before sending
   * @default false
   */
  checkSmsSettings?: boolean;
  /**
   * Whether to throw an error when notifications are disabled (if false, will skip silently)
   * @default false
   */
  throwErrorOnDisabled?: boolean;
}

export interface CreatePropertyDto {
  /**
   * Property name
   * @example "Modern apartment in the city center"
   */
  name: string;
  /**
   * Detailed description of the property
   * @example "Spacious apartment with modern renovation and panoramic windows"
   */
  description?: string;
  /**
   * Property type
   * @example "apartment"
   */
  type: "apartment" | "house" | "office" | "commercial" | "land";
  /**
   * Property status
   * @example "available"
   */
  status: "available" | "occupied" | "sold" | "pending" | "maintenance";
  /**
   * Property price
   * @min 0
   * @example 100000
   */
  price: number;
  /**
   * Property price currency
   * @example "USD"
   */
  currency: "USD";
  /**
   * Property address
   * @example "350 5th Ave"
   */
  address?: string;
  /**
   * City
   * @example "New York City"
   */
  city?: string;
  /**
   * State
   * @example "New York"
   */
  state?: string;
  /**
   * State abbreviation
   * @example "NY"
   */
  stateAbbreviation?: string;
  /**
   * Country
   * @example "United States"
   */
  country?: string;
  /**
   * Country abbreviation
   * @example "US"
   */
  countryAbbreviation?: string;
  /**
   * Postal code
   * @example "10001"
   */
  postalCode?: string;
  /**
   * Property area
   * @min 0
   * @example 1500
   */
  area?: number;
  /**
   * Area unit
   * @default "SQUARE_FEET"
   * @example "SQUARE_FEET"
   */
  areaUnit?: "SQUARE_FEET" | "SQUARE_METERS";
  /**
   * Number of rooms
   * @min 0
   * @example 3
   */
  rooms?: number;
  /**
   * Number of bathrooms
   * @min 0
   * @example 2
   */
  bathrooms?: number;
  /**
   * Floor
   * @min 0
   * @example 5
   */
  floor?: number;
  /**
   * Total number of floors in the building
   * @min 0
   * @example 9
   */
  totalFloors?: number;
  /**
   * Year of construction
   * @min 1800
   * @example 2020
   */
  yearBuilt?: number;
  /**
   * Features and amenities
   * @example ["Underground parking","Security","Playground"]
   */
  features?: string[];
  /**
   * Property images
   * @example ["image1.jpg","image2.jpg"]
   */
  images?: string[];
  /**
   * Property owner UUID (set automatically)
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  ownerUUID?: string;
  /**
   * Property manager UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  managerUUID?: string;
  /**
   * Geographic coordinates
   * @example {"type":"Point","coordinates":[30.5241,50.4501]}
   */
  geoLocation?: object;
  /**
   * Is property active
   * @default true
   * @example true
   */
  isActive?: boolean;
}

export interface ImageSizeResponseDto {
  /**
   * Image URL
   * @example "https://admin.propmanage.space/properties/123e4567/image.avif"
   */
  url: string;
  /**
   * Image width in pixels
   * @example 1920
   */
  width: number;
  /**
   * Image height in pixels
   * @example 1080
   */
  height: number;
  /**
   * File size in bytes
   * @example 2048576
   */
  size: number;
}

export interface PropertyImageResponseDto {
  /**
   * Unique image identifier
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  imageUUID: string;
  /** Full size image */
  fullSize: ImageSizeResponseDto;
  /** Thumbnail image */
  thumbnail: ImageSizeResponseDto;
  /**
   * Image order number
   * @example 0
   */
  order: number;
}

export interface PropertyResponseDto {
  /**
   * Unique property identifier
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  propertyUUID: string;
  /**
   * Property name
   * @example "Modern Apartment in City Center"
   */
  name: string;
  /**
   * Detailed property description
   * @example "Spacious apartment with modern renovation and panoramic windows"
   */
  description?: string;
  /**
   * Property type
   * @example "apartment"
   */
  type: "apartment" | "house" | "office" | "commercial" | "land";
  /**
   * Property status
   * @example "available"
   */
  status: "available" | "occupied" | "sold" | "pending" | "maintenance";
  /**
   * Property price
   * @min 0
   * @example 100000
   */
  price: number;
  /**
   * Price currency
   * @example "USD"
   */
  currency: "USD";
  /**
   * Property address
   * @example "350 5th Ave"
   */
  address?: string;
  /**
   * City
   * @example "New York City"
   */
  city?: string;
  /**
   * State
   * @example "New York"
   */
  state?: string;
  /**
   * State code
   * @example "NY"
   */
  stateAbbreviation?: string;
  /**
   * Country
   * @example "United States"
   */
  country?: string;
  /**
   * Country code
   * @example "US"
   */
  countryAbbreviation?: string;
  /**
   * Postal code
   * @example "10001"
   */
  postalCode?: string;
  /**
   * Property area
   * @min 0
   * @example 1500
   */
  area?: number;
  /**
   * Number of rooms
   * @min 0
   * @example 3
   */
  rooms?: number;
  /**
   * Number of bathrooms
   * @min 0
   * @example 2
   */
  bathrooms?: number;
  /**
   * Floor
   * @min 0
   * @example 5
   */
  floor?: number;
  /**
   * Total floors in building
   * @min 0
   * @example 9
   */
  totalFloors?: number;
  /**
   * Year built
   * @min 1800
   * @example 2020
   */
  yearBuilt?: number;
  /**
   * Features and amenities
   * @example ["Underground parking","Security","Playground"]
   */
  features?: string[];
  /**
   * Property images
   * @example [{"fullSize":{"url":"https://admin.propmanage.space/properties/123e4567/image.avif","width":1920,"height":1080,"size":2048576},"thumbnail":{"url":"https://admin.propmanage.space/properties/123e4567/image-thumbnail.avif","width":300,"height":169,"size":102400},"order":0}]
   */
  images?: PropertyImageResponseDto[];
  /**
   * Property owner UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  ownerUUID: string;
  /**
   * Property manager UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  managerUUID?: string;
  /**
   * Geographic coordinates
   * @example {"type":"Point","coordinates":[30.5241,50.4501]}
   */
  geoLocation?: object;
  /**
   * Is property active
   * @example true
   */
  isActive: boolean;
  /**
   * Record creation date
   * @format date-time
   * @example "2024-02-22T12:00:00Z"
   */
  createdAt: string;
  /**
   * Last update date
   * @format date-time
   * @example "2024-02-22T12:00:00Z"
   */
  updatedAt: string;
  /**
   * Last status change date
   * @format date-time
   * @example "2024-02-22T12:00:00Z"
   */
  lastStatusChange?: string;
}

export interface UpdatePropertyDto {
  /**
   * Property name
   * @example "Modern apartment in the city center"
   */
  name?: string;
  /**
   * Detailed description of the property
   * @example "Spacious apartment with modern renovation and panoramic windows"
   */
  description?: string;
  /**
   * Property type
   * @example "apartment"
   */
  type?: "apartment" | "house" | "office" | "commercial" | "land";
  /**
   * Property status
   * @example "available"
   */
  status?: "available" | "occupied" | "sold" | "pending" | "maintenance";
  /**
   * Property price
   * @min 0
   * @example 100000
   */
  price?: number;
  /**
   * Property price currency
   * @example "USD"
   */
  currency?: "USD";
  /**
   * Property address
   * @example "350 5th Ave"
   */
  address?: string;
  /**
   * City
   * @example "New York City"
   */
  city?: string;
  /**
   * State
   * @example "New York"
   */
  state?: string;
  /**
   * State abbreviation
   * @example "NY"
   */
  stateAbbreviation?: string;
  /**
   * Country
   * @example "United States"
   */
  country?: string;
  /**
   * Country abbreviation
   * @example "US"
   */
  countryAbbreviation?: string;
  /**
   * Postal code
   * @example "10001"
   */
  postalCode?: string;
  /**
   * Property area
   * @min 0
   * @example 1500
   */
  area?: number;
  /**
   * Area unit
   * @default "SQUARE_FEET"
   * @example "SQUARE_FEET"
   */
  areaUnit?: "SQUARE_FEET" | "SQUARE_METERS";
  /**
   * Number of rooms
   * @min 0
   * @example 3
   */
  rooms?: number;
  /**
   * Number of bathrooms
   * @min 0
   * @example 2
   */
  bathrooms?: number;
  /**
   * Floor
   * @min 0
   * @example 5
   */
  floor?: number;
  /**
   * Total number of floors in the building
   * @min 0
   * @example 9
   */
  totalFloors?: number;
  /**
   * Year of construction
   * @min 1800
   * @example 2020
   */
  yearBuilt?: number;
  /**
   * Features and amenities
   * @example ["Underground parking","Security","Playground"]
   */
  features?: string[];
  /**
   * Property images
   * @example ["image1.jpg","image2.jpg"]
   */
  images?: string[];
  /**
   * Property owner UUID (set automatically)
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  ownerUUID?: string;
  /**
   * Property manager UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  managerUUID?: string;
  /**
   * Geographical coordinates
   * @example {"type":"Point","coordinates":[-73.9967,40.7484]}
   */
  geoLocation?: object;
  /**
   * Property active status
   * @default true
   * @example true
   */
  isActive?: boolean;
}

export interface CreateLeaseDto {
  /**
   * Property UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  propertyUUID: string;
  /**
   * Tenant UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  tenantUUID?: string | null;
  /**
   * Manager UUID (optional)
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  managerUUID?: string;
  /**
   * Lease start date
   * @format date-time
   * @example "2023-01-01"
   */
  startDate: string;
  /**
   * Lease end date (optional)
   * @format date-time
   * @example "2024-01-01"
   */
  endDate?: string;
  /**
   * Monthly rent amount
   * @example 1500
   */
  monthlyRent: number;
  /**
   * Security deposit amount (optional)
   * @default 0
   * @example 1500
   */
  securityDeposit?: number;
  /**
   * Lease status (optional)
   * @default "PENDING"
   */
  status?: "ACTIVE" | "COMPLETED" | "CANCELED" | "PENDING";
  /**
   * Day of month for rent payment (optional)
   * @default 1
   * @example 1
   */
  paymentDay?: number;
  /**
   * Whether the lease should automatically renew (optional)
   * @default false
   * @example false
   */
  autoRenew?: boolean;
}

export type Property = object;

export interface Lease {
  /**
   * Unique identifier for the lease
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  leaseUUID: string;
  /** Property associated with this lease */
  property: Property;
  /**
   * UUID of the property
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  propertyUUID: string;
  /** Tenant associated with this lease */
  tenant?: User;
  /**
   * UUID of the tenant
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  tenantUUID?: string;
  /** Manager associated with this lease */
  manager: User;
  /**
   * UUID of the manager
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  managerUUID: string;
  /**
   * Start date of the lease
   * @format date-time
   * @example "2023-01-01"
   */
  startDate: string;
  /**
   * End date of the lease (if applicable)
   * @format date-time
   * @example "2024-01-01"
   */
  endDate?: string;
  /**
   * Monthly rent amount
   * @example 1500
   */
  monthlyRent: number;
  /**
   * Security deposit amount
   * @default 0
   * @example 1500
   */
  securityDeposit: number;
  /**
   * Current status of the lease
   * @default "PENDING"
   * @example "ACTIVE"
   */
  status: "ACTIVE" | "COMPLETED" | "CANCELED" | "PENDING";
  /**
   * Day of month when rent payment is due
   * @default 1
   * @example 1
   */
  paymentDay: number;
  /**
   * Whether the lease should automatically renew
   * @default false
   * @example false
   */
  autoRenew: boolean;
  /**
   * Date and time when the lease was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date and time when the lease was last updated
   * @format date-time
   * @example "2023-01-15T12:00:00Z"
   */
  updatedAt: string;
  /**
   * Date and time when the lease status was last changed
   * @format date-time
   * @example "2023-01-10T12:00:00Z"
   */
  lastStatusChange?: string;
}

export interface PaginatedLeasesDto {
  /**
   * Кількість елементів на поточній сторінці
   * @example 10
   */
  numberOfElements: number;
  /**
   * Розмір сторінки (кількість елементів на сторінці)
   * @example 20
   */
  size: number;
  /**
   * Номер поточної сторінки (починаючи з 0)
   * @example 0
   */
  page: number;
  /**
   * Загальна кількість елементів на всіх сторінках
   * @example 100
   */
  totalElements: number;
  /**
   * Загальна кількість сторінок
   * @example 5
   */
  totalPages: number;
  /**
   * Чи є поточна сторінка останньою
   * @example true
   */
  last: boolean;
  /**
   * Чи є поточна сторінка першою
   * @example false
   */
  first: boolean;
  /** Масив оренд на поточній сторінці */
  content: Lease[];
}

export interface UpdateLeaseDto {
  /**
   * Property UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  propertyUUID?: string;
  /**
   * Tenant UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  tenantUUID?: string | null;
  /**
   * Manager UUID
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  managerUUID?: string | null;
  /**
   * Lease start date
   * @format date-time
   * @example "2023-01-01"
   */
  startDate?: string;
  /**
   * Lease end date (optional)
   * @format date-time
   * @example "2024-01-01"
   */
  endDate?: string;
  /**
   * Monthly rent amount
   * @example 1500
   */
  monthlyRent?: number;
  /**
   * Security deposit amount (optional)
   * @default 0
   * @example 1500
   */
  securityDeposit?: number;
  /**
   * Lease status (optional)
   * @default "PENDING"
   */
  status?: "ACTIVE" | "COMPLETED" | "CANCELED" | "PENDING";
  /**
   * Day of month for rent payment (optional)
   * @default 1
   * @example 1
   */
  paymentDay?: number;
  /**
   * Whether the lease should automatically renew (optional)
   * @default false
   * @example false
   */
  autoRenew?: boolean;
}

export interface FeatureToggle {
  /**
   * Unique key identifier for the feature toggle
   * @example "enableCreateNewUser"
   */
  key: string;
  /**
   * Indicates whether the feature is enabled or disabled
   * @default false
   * @example false
   */
  enabled: boolean;
  /**
   * Username or ID of the last user who updated the toggle
   * @example "uuid"
   */
  updatedBy?: string | null;
  /**
   * Display order of the toggle in UI
   * @default 0
   * @example 1
   */
  order: number;
  /**
   * Timestamp of the last update
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  updatedAt: string;
  /**
   * Description of what the feature toggle controls
   * @example "Allows creating new users in the system"
   */
  description: string | null;
}

export interface UpdateFeatureToggleDto {
  /**
   * Indicates whether the feature is enabled or disabled
   * @example true
   */
  enabled: boolean;
  /**
   * Username or ID of the user who updated the feature toggle
   * @example "admin"
   */
  updatedBy?: string;
}

export interface UpdateFeatureToggleOrderDto {
  /**
   * Display order of the feature toggle in UI
   * @example 1
   */
  order: number;
  /**
   * Username or ID of the user who updated the order
   * @example "admin"
   */
  updatedBy?: string;
}

export type AppControllerHealthCheckData = string;

export type AuthControllerValidateTokenData = UserDto;

export type AuthControllerGoogleAuthData = AccessTokenDto;

export type AuthControllerLoginData = AccessTokenDto;

export type AuthControllerGetProfileData = UserDto;

export type AuthControllerChangePasswordData = HttpResponseDto;

export type AuthControllerRefreshData = AccessTokenDto;

export type UsersControllerCreateData = AccessTokenResponse;

export type UsersControllerFindAllData = PaginatedUserDto;

export type UsersControllerGetUserStatisticsData = UserStatisticsDto;

export type UsersControllerGetUserByEmailData = any;

export type UsersControllerGetUserByPhoneData = any;

export type UsersControllerFindByUuidsData = User[];

export type UsersControllerGetUserByUuidData = UserDto;

export type UsersControllerDeleteUserData = any;

export type UsersControllerUpdateUserData = any;

export type UsersControllerUploadAvatarData = AvatarUploadResponseDto;

export type UsersVerificationsControllerGeneratePasswordResetData = any;

export type UsersVerificationsControllerValidatePasswordResetData = any;

export type UsersVerificationsControllerResetPasswordData = any;

/** @example {"isEmailVerified":true} */
export type UsersVerificationsControllerVerifyVerificationCodeData = any;

/** @example {"isEmailVerified":true,"isPhoneVerified":false} */
export type UsersVerificationsControllerGetVerificationData = any;

export type UsersVerificationsControllerSendVerificationCodeData = any;

export type UsersVerificationsControllerVerifyCodeData = HttpResponseDto;

export type UserNotificationsSettingsControllerGetSettingsData = UserNotificationsSettings;

export type UserNotificationsSettingsControllerUpdateSettingsData = UserNotificationsSettings;

export type UserAuditLogsControllerFindLogsData = PaginatedUserAuditLogDto;

export type UserAuditLogsControllerDeleteAuditLogData = HttpResponseDto;

export type UserSettingsControllerGetSettingsData = UserSettings;

export type UserSettingsControllerUpdateSettingsData = UserSettings;

export type NotifyControllerSendBulkMailData = any;

export type NotifyControllerSendBulkSmsData = any;

export type SeedControllerSeedUsersData = any;

export type SeedControllerClearSeedDataData = any;

export type PropertiesControllerCreateData = PropertyResponseDto;

export interface PropertiesControllerFindAllData {
  /**
   * Number of elements on current page
   * @example 10
   */
  numberOfElements?: number;
  /**
   * Page size
   * @example 20
   */
  size?: number;
  /**
   * Current page number
   * @example 0
   */
  page?: number;
  /**
   * Total number of elements
   * @example 100
   */
  totalElements?: number;
  /**
   * Total number of pages
   * @example 5
   */
  totalPages?: number;
  /**
   * Is current page the last one
   * @example false
   */
  last?: boolean;
  /**
   * Is current page the first one
   * @example true
   */
  first?: boolean;
  /** Array of property objects */
  content?: PropertyResponseDto[];
}

export type PropertiesControllerFindOneData = PropertyResponseDto;

export type PropertiesControllerUpdateData = PropertyResponseDto;

export type PropertiesControllerRemoveData = any;

export type PropertiesControllerUpdateStatusData = PropertyResponseDto;

export type PropertiesControllerFindByOwnerData = PropertyResponseDto[];

export type PropertiesControllerFindByManagerData = PropertyResponseDto[];

export type PropertiesControllerAssignManagerData = PropertyResponseDto;

export type PropertiesControllerRemoveManagerData = PropertyResponseDto;

export type PropertiesControllerAssignOwnerData = PropertyResponseDto;

export type PropertiesControllerRemoveOwnerData = PropertyResponseDto;

export interface PropertiesControllerUploadImagesData {
  images?: PropertyImageResponseDto[];
}

export type PropertiesControllerReorderImagesData = PropertyResponseDto;

export type PropertiesControllerDeleteImageData = PropertyResponseDto;

export type PropertiesControllerDeleteAllImagesData = PropertyResponseDto;

export type LeasesControllerCreateData = Lease;

export type LeasesControllerFindAllData = PaginatedLeasesDto;

export type LeasesControllerFindOneData = Lease;

export type LeasesControllerUpdateData = Lease;

export type LeasesControllerRemoveData = any;

export type LeasesControllerUpdateStatusData = Lease;

export type FeatureToggleControllerGetAllFeatureTogglesData = FeatureToggle[];

/** @example {"enableCreateNewUser":false,"enableCreateNewProperty":true} */
export type FeatureToggleControllerGetFeatureTogglesForFrontendData = Record<string, boolean>;

export type FeatureToggleControllerGetFeatureToggleData = FeatureToggle;

export type FeatureToggleControllerUpdateFeatureToggleData = FeatureToggle;

export type FeatureToggleControllerUpdateFeatureToggleOrderData = FeatureToggle;

/** @example {"enableCreateNewUser":false,"enableCreateNewProperty":true} */
export type FeatureTogglePublicControllerGetFeatureTogglesForFrontendData = Record<string, boolean>;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Prop-manage API Documentation
 * @version 1.0
 * @contact
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  healthCheck = {
    /**
     * No description
     *
     * @tags Health check
     * @name AppControllerHealthCheck
     * @summary Health check
     * @request GET:/health-check
     * @response `200` `AppControllerHealthCheckData` Server is healthy
     * @response `400` `HttpResponseDto` Bad request
     */
    appControllerHealthCheck: (params: RequestParams = {}) =>
      this.request<AppControllerHealthCheckData, HttpResponseDto>({
        path: `/health-check`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerValidateToken
     * @summary Validate JWT token
     * @request POST:/auth/validate-token
     * @response `200` `AuthControllerValidateTokenData` Token successfully validated
     * @response `401` `HttpResponseDto` Invalid or expired token
     */
    authControllerValidateToken: (data: ValidateTokenDto, params: RequestParams = {}) =>
      this.request<AuthControllerValidateTokenData, HttpResponseDto>({
        path: `/auth/validate-token`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerGoogleAuth
     * @summary Authenticate with Google OAuth token
     * @request POST:/auth/google-auth
     * @response `201` `AuthControllerGoogleAuthData` User successfully authenticated with Google
     * @response `400` `HttpResponseDto` Invalid Google token or authentication failed
     */
    authControllerGoogleAuth: (data: GoogleAuthDto, params: RequestParams = {}) =>
      this.request<AuthControllerGoogleAuthData, HttpResponseDto>({
        path: `/auth/google-auth`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerLogin
     * @summary Login
     * @request POST:/auth/login
     * @response `201` `AuthControllerLoginData` User successfully logged in
     */
    authControllerLogin: (data: CreateAuthDto, params: RequestParams = {}) =>
      this.request<AuthControllerLoginData, any>({
        path: `/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerGetProfile
     * @summary Get profile
     * @request GET:/auth/profile
     * @secure
     * @response `200` `AuthControllerGetProfileData` User successfully logged in
     * @response `400` `HttpResponseDto` Bad request
     */
    authControllerGetProfile: (params: RequestParams = {}) =>
      this.request<AuthControllerGetProfileData, HttpResponseDto>({
        path: `/auth/profile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerChangePassword
     * @summary Change password
     * @request POST:/auth/change-password
     * @secure
     * @response `200` `AuthControllerChangePasswordData` Password successfully changed
     */
    authControllerChangePassword: (data: UpdatePasswordAuthDto, params: RequestParams = {}) =>
      this.request<AuthControllerChangePasswordData, any>({
        path: `/auth/change-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthControllerRefresh
     * @summary Refresh token
     * @request POST:/auth/refresh-token
     * @secure
     * @response `200` `AuthControllerRefreshData` Token successfully refreshed
     * @response `401` `HttpResponseDto` Bad request
     */
    authControllerRefresh: (params: RequestParams = {}) =>
      this.request<AuthControllerRefreshData, HttpResponseDto>({
        path: `/auth/refresh-token`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerCreate
     * @summary Create user
     * @request POST:/users/create
     * @response `201` `UsersControllerCreateData` User created
     * @response `400` `void` Bad request
     */
    usersControllerCreate: (
      data: {
        /**
         * The email of the user
         * @example "admin@example.com"
         */
        email: string;
        /**
         * The password of the user
         * @example "admin123"
         */
        password: string;
        /**
         * The role of the user (TENANT, ADMIN, OWNER, STAFF, UNASSIGNED)
         * @example "ADMIN"
         */
        role?: string;
        /**
         * The first name of the user
         * @example "John"
         */
        firstName?: string;
        /**
         * The last name of the user
         * @example "Doe"
         */
        lastName?: string;
        /**
         * The phone number of the user
         * @example "1234567890"
         */
        phoneNumber?: string;
        /**
         * The status of the user (PENDING, ACTIVE, INACTIVE)
         * @example "PENDING"
         */
        status?: string;
        /**
         * The birth date of the user
         * @example "1990-01-01"
         */
        birthDate?: string;
        /**
         * Whether the user is active
         * @example true
         */
        isActive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersControllerCreateData, void>({
        path: `/users/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerFindAll
     * @summary Отримати список всіх користувачів з пагінацією
     * @request GET:/users
     * @response `200` `UsersControllerFindAllData` Успішно отримано список користувачів
     * @response `400` `HttpResponseDto` Неправильні параметри запиту
     */
    usersControllerFindAll: (
      query?: {
        /**
         * Номер сторінки (починається з 0)
         * @default 0
         * @example 0
         */
        page?: number;
        /**
         * Кількість елементів на сторінці
         * @default 10
         * @example 10
         */
        size?: number;
        /** Search keyword to filter users by UUID, name, email or phone */
        keyword?: string;
        /** Filter users by role */
        role?: UserRole;
        /** Filter users by status */
        status?: UserStatus;
        /** Filter users by active status */
        isActive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersControllerFindAllData, HttpResponseDto>({
        path: `/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns statistics about users including total count, active, pending and inactive users. Cached for 5 minutes.
     *
     * @tags Users
     * @name UsersControllerGetUserStatistics
     * @summary Get users statistics
     * @request GET:/users/statistics
     * @response `200` `UsersControllerGetUserStatisticsData` Successfully retrieved user statistics
     * @response `401` `HttpResponseDto` Unauthorized - JWT token is missing or invalid
     * @response `500` `HttpResponseDto` Internal server error while fetching statistics
     */
    usersControllerGetUserStatistics: (params: RequestParams = {}) =>
      this.request<UsersControllerGetUserStatisticsData, HttpResponseDto>({
        path: `/users/statistics`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerGetUserByEmail
     * @request GET:/users/find-by-email/{email}
     * @response `200` `UsersControllerGetUserByEmailData`
     */
    usersControllerGetUserByEmail: (email: string, params: RequestParams = {}) =>
      this.request<UsersControllerGetUserByEmailData, any>({
        path: `/users/find-by-email/${email}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerGetUserByPhone
     * @request GET:/users/find-by-phone/{phone}
     * @response `200` `UsersControllerGetUserByPhoneData`
     */
    usersControllerGetUserByPhone: (phone: string, params: RequestParams = {}) =>
      this.request<UsersControllerGetUserByPhoneData, any>({
        path: `/users/find-by-phone/${phone}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerFindByUuids
     * @summary Find users by UUIDs
     * @request POST:/users/uuids
     * @response `201` `UsersControllerFindByUuidsData` Found users
     * @response `400` `void` Bad request
     */
    usersControllerFindByUuids: (
      data: {
        uuids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersControllerFindByUuidsData, void>({
        path: `/users/uuids`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Повертає детальну інформацію про користувача за його унікальним ідентифікатором (UUID).
     *
     * @tags Users
     * @name UsersControllerGetUserByUuid
     * @summary Отримати користувача за UUID
     * @request GET:/users/{userUUID}
     * @response `200` `UsersControllerGetUserByUuidData` Користувача успішно знайдено
     * @response `400` `HttpResponseDto` Неправильний формат UUID
     * @response `404` `HttpResponseDto` Користувача не знайдено
     * @response `500` `HttpResponseDto` Внутрішня помилка сервера
     */
    usersControllerGetUserByUuid: (userUuid: string, params: RequestParams = {}) =>
      this.request<UsersControllerGetUserByUuidData, HttpResponseDto>({
        path: `/users/${userUuid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerDeleteUser
     * @request DELETE:/users/{userUUID}
     * @response `200` `UsersControllerDeleteUserData`
     */
    usersControllerDeleteUser: (
      userUuid: string,
      query: {
        hardDelete: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersControllerDeleteUserData, any>({
        path: `/users/${userUuid}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersControllerUpdateUser
     * @summary Update user
     * @request PATCH:/users/{userUUID}
     * @response `200` `UsersControllerUpdateUserData` User updated
     * @response `400` `void` Bad request
     */
    usersControllerUpdateUser: (userUuid: string, data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<UsersControllerUpdateUserData, void>({
        path: `/users/${userUuid}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Uploads and processes user avatar image with automatic optimization and thumbnail generation
     *
     * @tags Users
     * @name UsersControllerUploadAvatar
     * @summary Upload user avatar
     * @request POST:/users/{userUUID}/avatar
     * @response `200` `UsersControllerUploadAvatarData` Avatar successfully uploaded and processed
     * @response `400` `HttpResponseDto` Bad request - invalid file type or size
     * @response `401` `HttpResponseDto` Unauthorized - JWT token is missing or invalid
     * @response `500` `HttpResponseDto` Internal server error while processing image
     */
    usersControllerUploadAvatar: (userUuid: string, params: RequestParams = {}) =>
      this.request<UsersControllerUploadAvatarData, HttpResponseDto>({
        path: `/users/${userUuid}/avatar`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  usersVerifications = {
    /**
     * @description Generates a password reset code and sends it to the user email.
     *
     * @tags Users Verifications
     * @name UsersVerificationsControllerGeneratePasswordReset
     * @summary Generate password reset code
     * @request POST:/users-verifications/generate-password-reset
     * @response `200` `UsersVerificationsControllerGeneratePasswordResetData` Password reset code has been generated and sent to email.
     * @response `404` `void` User not found
     */
    usersVerificationsControllerGeneratePasswordReset: (
      data: {
        /**
         * Email address of the user requesting password reset
         * @example "user@example.com"
         */
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersVerificationsControllerGeneratePasswordResetData, void>({
        path: `/users-verifications/generate-password-reset`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Validates the provided password reset code.
     *
     * @tags Users Verifications
     * @name UsersVerificationsControllerValidatePasswordReset
     * @summary Validate password reset code
     * @request POST:/users-verifications/validate-password-reset
     * @response `200` `UsersVerificationsControllerValidatePasswordResetData` Password reset code is valid.
     * @response `400` `void` Invalid or expired reset code
     * @response `404` `void` User not found
     */
    usersVerificationsControllerValidatePasswordReset: (
      data: {
        /**
         * Email address of the user
         * @example "user@example.com"
         */
        email: string;
        /**
         * Password reset code to validate
         * @example "123e4567-e89b-12d3-a456-426614174000"
         */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersVerificationsControllerValidatePasswordResetData, void>({
        path: `/users-verifications/validate-password-reset`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sets a new password using a valid reset code.
     *
     * @tags Users Verifications
     * @name UsersVerificationsControllerResetPassword
     * @summary Reset password
     * @request POST:/users-verifications/reset-password
     * @response `200` `UsersVerificationsControllerResetPasswordData` Password has been successfully reset.
     * @response `400` `void` Invalid/expired code or passwords do not match
     * @response `404` `void` Reset code not found
     */
    usersVerificationsControllerResetPassword: (
      data: {
        /**
         * Valid password reset code received via email
         * @example "123e4567-e89b-12d3-a456-426614174000"
         */
        code: string;
        /**
         * New password
         * @example "newSecurePassword123!"
         */
        newPassword: string;
        /**
         * Confirm new password
         * @example "newSecurePassword123!"
         */
        confirmPassword: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersVerificationsControllerResetPasswordData, void>({
        path: `/users-verifications/reset-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Checks if the provided verification code (email or phone) is valid and marks the respective field as verified.
     *
     * @tags Users Verifications
     * @name UsersVerificationsControllerVerifyVerificationCode
     * @summary Verify verification code
     * @request POST:/users-verifications/verify-verification-code
     * @secure
     * @response `200` `UsersVerificationsControllerVerifyVerificationCodeData` Returns an object containing the verification status (e.g., { isEmailVerified: true }).
     * @response `400` `void` Invalid verification code
     * @response `404` `void` Verification record not found
     */
    usersVerificationsControllerVerifyVerificationCode: (
      data: {
        /**
         * Type of verification to verify
         * @example "emailVerificationCode"
         */
        type?: "emailVerificationCode" | "phoneVerificationCode";
        /**
         * Verification code to verify
         * @example "123456"
         */
        code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersVerificationsControllerVerifyVerificationCodeData, void>({
        path: `/users-verifications/verify-verification-code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the current verification status of the users phone and email.
     *
     * @tags Users Verifications
     * @name UsersVerificationsControllerGetVerification
     * @summary Get current verification status
     * @request GET:/users-verifications/get-verification
     * @secure
     * @response `200` `UsersVerificationsControllerGetVerificationData` Returns an object with isEmailVerified and isPhoneVerified fields.
     */
    usersVerificationsControllerGetVerification: (params: RequestParams = {}) =>
      this.request<UsersVerificationsControllerGetVerificationData, any>({
        path: `/users-verifications/get-verification`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Generates and sends a verification code (via SMS for phone or email for email verification).
     *
     * @tags Users Verifications
     * @name UsersVerificationsControllerSendVerificationCode
     * @summary Send verification code
     * @request POST:/users-verifications/send-verification-code
     * @secure
     * @response `201` `UsersVerificationsControllerSendVerificationCodeData` Verification code successfully sent via email or SMS.
     * @response `400` `void` Invalid verification type
     */
    usersVerificationsControllerSendVerificationCode: (
      data: {
        /**
         * Type of verification to send code for
         * @example "emailVerificationCode"
         */
        type?: "emailVerificationCode" | "phoneVerificationCode";
      },
      params: RequestParams = {},
    ) =>
      this.request<UsersVerificationsControllerSendVerificationCodeData, void>({
        path: `/users-verifications/send-verification-code`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Verify the code sent to user
     *
     * @tags Users Verifications
     * @name UsersVerificationsControllerVerifyCode
     * @summary Verify code
     * @request POST:/users-verifications/verify-code
     * @secure
     * @response `200` `UsersVerificationsControllerVerifyCodeData` Code verified successfully
     * @response `400` `HttpResponseDto` Invalid verification code
     */
    usersVerificationsControllerVerifyCode: (params: RequestParams = {}) =>
      this.request<UsersVerificationsControllerVerifyCodeData, HttpResponseDto>({
        path: `/users-verifications/verify-code`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  usersNotificationsSettings = {
    /**
     * @description Returns current notification settings for the authorized user
     *
     * @tags User Notification Settings
     * @name UserNotificationsSettingsControllerGetSettings
     * @summary Get user notification settings
     * @request GET:/users-notifications-settings
     * @secure
     * @response `200` `UserNotificationsSettingsControllerGetSettingsData` Notification settings retrieved successfully
     * @response `401` `void` User is not authorized
     * @response `404` `void` Notification settings not found
     */
    userNotificationsSettingsControllerGetSettings: (params: RequestParams = {}) =>
      this.request<UserNotificationsSettingsControllerGetSettingsData, void>({
        path: `/users-notifications-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates notification settings for the authorized user. Individual settings can be updated separately.
     *
     * @tags User Notification Settings
     * @name UserNotificationsSettingsControllerUpdateSettings
     * @summary Update user notification settings
     * @request PATCH:/users-notifications-settings
     * @secure
     * @response `200` `UserNotificationsSettingsControllerUpdateSettingsData` Notification settings updated successfully
     * @response `400` `void` Invalid data format
     * @response `401` `void` User is not authorized
     * @response `404` `void` Notification settings not found
     */
    userNotificationsSettingsControllerUpdateSettings: (
      data: UpdateNotificationsSettingsDto,
      params: RequestParams = {},
    ) =>
      this.request<UserNotificationsSettingsControllerUpdateSettingsData, void>({
        path: `/users-notifications-settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userAuditLogs = {
    /**
     * @description Retrieves a paginated list of user audit logs with optional filters for date range and action type. The response includes pagination metadata.
     *
     * @tags User Audit Logs
     * @name UserAuditLogsControllerFindLogs
     * @summary Find user audit logs with filters and pagination
     * @request GET:/user-audit-logs
     * @secure
     * @response `200` `UserAuditLogsControllerFindLogsData` Successfully retrieved paginated user audit logs
     * @response `400` `void` Invalid filter parameters
     * @response `401` `void` Unauthorized
     * @response `403` `void` User ID is required
     */
    userAuditLogsControllerFindLogs: (
      query: {
        /** UUID of the user to get audit logs for */
        userId: string;
        /**
         * Start date for filtering logs (ISO format)
         * @format date-time
         */
        startDate?: string;
        /**
         * End date for filtering logs (ISO format)
         * @format date-time
         */
        endDate?: string;
        /** Type of audit action to filter by */
        action?:
          | "UPDATE_PROFILE"
          | "DELETE_PROFILE"
          | "CHANGE_PASSWORD"
          | "CHANGE_EMAIL"
          | "CHANGE_PHONE"
          | "UPDATE_NOTIFICATIONS"
          | "UPDATE_SETTINGS"
          | "ACTIVATE_ACCOUNT"
          | "DEACTIVATE_ACCOUNT"
          | "BLOCK_ACCOUNT"
          | "LOGIN"
          | "LOGOUT"
          | "FAILED_LOGIN"
          | "EMAIL_VERIFIED"
          | "PHONE_VERIFIED"
          | "CHANGE_ROLE";
        /**
         * Page number (zero-based)
         * @default 0
         * @example 0
         */
        page?: number;
        /**
         * Number of items per page
         * @default 10
         * @example 10
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserAuditLogsControllerFindLogsData, void>({
        path: `/user-audit-logs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete specific audit log by ID
     *
     * @tags User Audit Logs
     * @name UserAuditLogsControllerDeleteAuditLog
     * @summary Delete audit log
     * @request DELETE:/user-audit-logs/{id}
     * @secure
     * @response `200` `UserAuditLogsControllerDeleteAuditLogData` Audit log successfully deleted
     * @response `400` `void` Bad Request
     * @response `401` `void` Unauthorized
     * @response `403` `void` Forbidden resource
     * @response `404` `void` Audit log not found
     */
    userAuditLogsControllerDeleteAuditLog: (id: string, params: RequestParams = {}) =>
      this.request<UserAuditLogsControllerDeleteAuditLogData, void>({
        path: `/user-audit-logs/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  userSettings = {
    /**
     * @description Returns current settings for the authorized user
     *
     * @tags User Settings
     * @name UserSettingsControllerGetSettings
     * @summary Get user settings
     * @request GET:/user-settings
     * @secure
     * @response `200` `UserSettingsControllerGetSettingsData` Settings retrieved successfully
     * @response `401` `void` Unauthorized
     * @response `404` `void` Settings not found
     */
    userSettingsControllerGetSettings: (params: RequestParams = {}) =>
      this.request<UserSettingsControllerGetSettingsData, void>({
        path: `/user-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates settings for the authorized user
     *
     * @tags User Settings
     * @name UserSettingsControllerUpdateSettings
     * @summary Update user settings
     * @request PATCH:/user-settings/update/{userUUID}
     * @secure
     * @response `200` `UserSettingsControllerUpdateSettingsData` Settings updated successfully
     * @response `400` `void` Invalid data format
     * @response `401` `void` Unauthorized
     * @response `404` `void` Settings not found
     */
    userSettingsControllerUpdateSettings: (userUuid: string, data: UpdateUserSettingsDto, params: RequestParams = {}) =>
      this.request<UserSettingsControllerUpdateSettingsData, void>({
        path: `/user-settings/update/${userUuid}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  notify = {
    /**
     * No description
     *
     * @tags Notify
     * @name NotifyControllerSendBulkMail
     * @summary Send bulk email
     * @request POST:/notify/send-bulk-email
     * @response `201` `NotifyControllerSendBulkMailData`
     */
    notifyControllerSendBulkMail: (data: SendMailDto, params: RequestParams = {}) =>
      this.request<NotifyControllerSendBulkMailData, any>({
        path: `/notify/send-bulk-email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notify
     * @name NotifyControllerSendBulkSms
     * @request POST:/notify/send-bulk-sms
     * @response `201` `NotifyControllerSendBulkSmsData`
     */
    notifyControllerSendBulkSms: (data: SendSmsDto, params: RequestParams = {}) =>
      this.request<NotifyControllerSendBulkSmsData, any>({
        path: `/notify/send-bulk-sms`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  seed = {
    /**
     * No description
     *
     * @tags Seed
     * @name SeedControllerSeedUsers
     * @summary Створити тестових користувачів
     * @request POST:/seed/users
     * @response `201` `SeedControllerSeedUsersData` Тестові користувачі успішно створені
     */
    seedControllerSeedUsers: (
      query?: {
        /** Кількість користувачів для створення (за замовчуванням: 50) */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SeedControllerSeedUsersData, any>({
        path: `/seed/users`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seed
     * @name SeedControllerClearSeedData
     * @summary Очистити всі тестові дані
     * @request POST:/seed/clear
     * @response `200` `SeedControllerClearSeedDataData` Всі тестові дані успішно видалені
     */
    seedControllerClearSeedData: (params: RequestParams = {}) =>
      this.request<SeedControllerClearSeedDataData, any>({
        path: `/seed/clear`,
        method: "POST",
        ...params,
      }),
  };
  properties = {
    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerCreate
     * @summary Create property
     * @request POST:/properties
     * @secure
     * @response `201` `PropertiesControllerCreateData` Property successfully created
     * @response `400` `void` Bad request
     * @response `401` `void` Authorization required
     */
    propertiesControllerCreate: (data: CreatePropertyDto, params: RequestParams = {}) =>
      this.request<PropertiesControllerCreateData, void>({
        path: `/properties`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerFindAll
     * @summary Get list of properties with filters and pagination
     * @request GET:/properties
     * @secure
     * @response `200` `PropertiesControllerFindAllData` Returns paginated list of properties
     * @response `401` `void` Authorization required
     */
    propertiesControllerFindAll: (
      query?: {
        /**
         * Page number
         * @min 0
         * @default 0
         * @example 0
         */
        page?: number;
        /**
         * Number of elements per page
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Search by name or description
         * @example "apartment center"
         */
        search?: string;
        /**
         * Property type
         * @example "apartment"
         */
        type?: "apartment" | "house" | "office" | "commercial" | "land";
        /**
         * Property status
         * @example "available"
         */
        status?: "available" | "occupied" | "sold" | "pending" | "maintenance";
        /**
         * Minimum price
         * @min 0
         * @example 50000
         */
        minPrice?: number;
        /**
         * Maximum price
         * @min 0
         * @example 150000
         */
        maxPrice?: number;
        /**
         * Price currency
         * @example "USD"
         */
        currency?: "USD";
        /**
         * City
         * @example "Kyiv"
         */
        city?: string;
        /**
         * Minimum property area
         * @min 0
         * @example 50
         */
        minArea?: number;
        /**
         * Maximum property area
         * @min 0
         * @example 150
         */
        maxArea?: number;
        /**
         * Area unit
         * @example "SQUARE_FEET"
         */
        areaUnit?: "SQUARE_FEET" | "SQUARE_METERS";
        /**
         * Minimum number of rooms
         * @min 0
         * @example 2
         */
        minRooms?: number;
        /**
         * Maximum number of rooms
         * @min 0
         * @example 4
         */
        maxRooms?: number;
        /**
         * Features and amenities
         * @example ["Underground parking","Security"]
         */
        features?: string[];
        /**
         * Search radius in kilometers
         * @min 0
         * @example 5
         */
        radius?: number;
        /**
         * Latitude for location search
         * @example "50.4501"
         */
        latitude?: string;
        /**
         * Longitude for location search
         * @example "30.5241"
         */
        longitude?: string;
        /**
         * Sort field
         * @example "price"
         */
        sortBy?: "price" | "createdAt" | "area" | "rooms";
        /**
         * Sort order
         * @default "DESC"
         * @example "DESC"
         */
        sortOrder?: "ASC" | "DESC";
      },
      params: RequestParams = {},
    ) =>
      this.request<PropertiesControllerFindAllData, void>({
        path: `/properties`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerFindOne
     * @summary Get property by UUID
     * @request GET:/properties/{uuid}
     * @secure
     * @response `200` `PropertiesControllerFindOneData` Returns information about specific property
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerFindOne: (uuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerFindOneData, void>({
        path: `/properties/${uuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerUpdate
     * @summary Update property by UUID
     * @request PATCH:/properties/{uuid}
     * @secure
     * @response `200` `PropertiesControllerUpdateData` Property successfully updated
     * @response `400` `void` Bad request
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerUpdate: (uuid: string, data: UpdatePropertyDto, params: RequestParams = {}) =>
      this.request<PropertiesControllerUpdateData, void>({
        path: `/properties/${uuid}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerRemove
     * @summary Delete property by UUID
     * @request DELETE:/properties/{uuid}
     * @secure
     * @response `204` `PropertiesControllerRemoveData` Property successfully deleted
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerRemove: (uuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerRemoveData, void>({
        path: `/properties/${uuid}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerUpdateStatus
     * @summary Update property status
     * @request PATCH:/properties/{uuid}/status
     * @secure
     * @response `200` `PropertiesControllerUpdateStatusData` Property successfully updated
     * @response `400` `void` Bad request
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerUpdateStatus: (uuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerUpdateStatusData, void>({
        path: `/properties/${uuid}/status`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerFindByOwner
     * @summary Get list of properties by owner UUID
     * @request GET:/properties/owner/{ownerUUID}
     * @secure
     * @response `200` `PropertiesControllerFindByOwnerData` Returns list of properties for specific owner
     * @response `401` `void` Authorization required
     */
    propertiesControllerFindByOwner: (ownerUuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerFindByOwnerData, void>({
        path: `/properties/owner/${ownerUuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerFindByManager
     * @summary Get list of properties by manager UUID
     * @request GET:/properties/manager/{managerUUID}
     * @secure
     * @response `200` `PropertiesControllerFindByManagerData` Returns list of properties for specific manager
     * @response `401` `void` Authorization required
     */
    propertiesControllerFindByManager: (managerUuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerFindByManagerData, void>({
        path: `/properties/manager/${managerUuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerAssignManager
     * @summary Assign manager to property
     * @request PATCH:/properties/{uuid}/manager/{managerUUID}
     * @secure
     * @response `200` `PropertiesControllerAssignManagerData` Property successfully updated
     * @response `400` `void` Bad request
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerAssignManager: (uuid: string, managerUuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerAssignManagerData, void>({
        path: `/properties/${uuid}/manager/${managerUuid}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerRemoveManager
     * @summary Remove manager from property
     * @request DELETE:/properties/{uuid}/manager
     * @secure
     * @response `200` `PropertiesControllerRemoveManagerData` Property successfully updated
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerRemoveManager: (uuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerRemoveManagerData, void>({
        path: `/properties/${uuid}/manager`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerAssignOwner
     * @summary Assign owner to property
     * @request PATCH:/properties/{uuid}/owner
     * @secure
     * @response `200` `PropertiesControllerAssignOwnerData` Property successfully updated
     * @response `400` `void` Bad request
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerAssignOwner: (uuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerAssignOwnerData, void>({
        path: `/properties/${uuid}/owner`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerRemoveOwner
     * @summary Remove owner from property
     * @request DELETE:/properties/{uuid}/owner
     * @secure
     * @response `200` `PropertiesControllerRemoveOwnerData` Property successfully updated
     * @response `401` `void` Authorization required
     * @response `404` `void` Property not found
     */
    propertiesControllerRemoveOwner: (uuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerRemoveOwnerData, void>({
        path: `/properties/${uuid}/owner`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Upload one or more images for a property. Supports jpg, jpeg, png, webp formats. Maximum file size is 5MB.
 *
 * @tags Properties
 * @name PropertiesControllerUploadImages
 * @summary Upload images for property
 * @request POST:/properties/{uuid}/images
 * @secure
 * @response `201` `PropertiesControllerUploadImagesData` Images successfully uploaded
 * @response `400` `{
  \** @example ["File must be an image","Maximum file size is 5MB","Supported formats: jpg, jpeg, png, webp"] *\
    message?: (string)[],
  \** @example "Bad Request" *\
    error?: string,
  \** @example 400 *\
    statusCode?: number,

}` Validation error
 */
    propertiesControllerUploadImages: (
      uuid: string,
      data: {
        files: File[];
        /**
         * Starting order number for uploaded images
         * @default 0
         */
        startOrder?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PropertiesControllerUploadImagesData,
        {
          /** @example ["File must be an image","Maximum file size is 5MB","Supported formats: jpg, jpeg, png, webp"] */
          message?: string[];
          /** @example "Bad Request" */
          error?: string;
          /** @example 400 */
          statusCode?: number;
        }
      >({
        path: `/properties/${uuid}/images`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
 * @description Update display order of images for a property
 *
 * @tags Properties
 * @name PropertiesControllerReorderImages
 * @summary Change image order
 * @request PATCH:/properties/{uuid}/images/reorder
 * @secure
 * @response `200` `PropertiesControllerReorderImagesData` Image order successfully updated
 * @response `400` `{
  \** @example ["File must be an image","Maximum file size is 5MB","Supported formats: jpg, jpeg, png, webp"] *\
    message?: (string)[],
  \** @example "Bad Request" *\
    error?: string,
  \** @example 400 *\
    statusCode?: number,

}` Validation error
 */
    propertiesControllerReorderImages: (
      uuid: string,
      data: {
        imageOrders: {
          /** Unique image identifier */
          imageUUID?: string;
          /** New order number */
          order?: number;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PropertiesControllerReorderImagesData,
        {
          /** @example ["File must be an image","Maximum file size is 5MB","Supported formats: jpg, jpeg, png, webp"] */
          message?: string[];
          /** @example "Bad Request" */
          error?: string;
          /** @example 400 */
          statusCode?: number;
        }
      >({
        path: `/properties/${uuid}/images/reorder`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Delete specified image from property and cloud storage
 *
 * @tags Properties
 * @name PropertiesControllerDeleteImage
 * @summary Delete image
 * @request DELETE:/properties/{uuid}/images/{imageUUID}
 * @secure
 * @response `200` `PropertiesControllerDeleteImageData` Image successfully deleted
 * @response `400` `{
  \** @example ["File must be an image","Maximum file size is 5MB","Supported formats: jpg, jpeg, png, webp"] *\
    message?: (string)[],
  \** @example "Bad Request" *\
    error?: string,
  \** @example 400 *\
    statusCode?: number,

}` Validation error
 */
    propertiesControllerDeleteImage: (uuid: string, imageUuid: string, params: RequestParams = {}) =>
      this.request<
        PropertiesControllerDeleteImageData,
        {
          /** @example ["File must be an image","Maximum file size is 5MB","Supported formats: jpg, jpeg, png, webp"] */
          message?: string[];
          /** @example "Bad Request" */
          error?: string;
          /** @example 400 */
          statusCode?: number;
        }
      >({
        path: `/properties/${uuid}/images/${imageUuid}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Properties
     * @name PropertiesControllerDeleteAllImages
     * @summary Delete all images of a property
     * @request DELETE:/properties/{propertyUUID}/images
     * @secure
     * @response `200` `PropertiesControllerDeleteAllImagesData` All images have been successfully deleted
     * @response `400` `void` Property has no images
     * @response `404` `void` Property not found
     */
    propertiesControllerDeleteAllImages: (propertyUuid: string, params: RequestParams = {}) =>
      this.request<PropertiesControllerDeleteAllImagesData, void>({
        path: `/properties/${propertyUuid}/images`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  leases = {
    /**
     * @description Creates a new lease agreement between a tenant and a property owner, managed by an optional property manager.
     *
     * @tags Leases Management
     * @name LeasesControllerCreate
     * @summary Create a new lease
     * @request POST:/leases
     * @secure
     * @response `201` `LeasesControllerCreateData` The lease has been successfully created.
     * @response `400` `void` Invalid input data.
     * @response `401` `void` Unauthorized access.
     * @response `403` `void` Forbidden. You do not have permission to create leases.
     */
    leasesControllerCreate: (data: CreateLeaseDto, params: RequestParams = {}) =>
      this.request<LeasesControllerCreateData, void>({
        path: `/leases`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a list of all lease agreements with related property, tenant, and manager details. Results are filtered based on user role.
     *
     * @tags Leases Management
     * @name LeasesControllerFindAll
     * @summary Get all leases
     * @request GET:/leases
     * @secure
     * @response `200` `LeasesControllerFindAllData` Returns all leases matching the specified filters and user role permissions.
     * @response `401` `void` Unauthorized access.
     * @response `403` `void` Forbidden. You do not have permission to view leases.
     */
    leasesControllerFindAll: (
      query?: {
        /** Filter leases by status */
        status?: "ACTIVE" | "COMPLETED" | "CANCELED" | "PENDING";
        /** Filter leases by property UUID */
        propertyUUID?: string;
        /** Filter leases by tenant UUID */
        tenantUUID?: string;
        /** Filter leases by manager UUID */
        managerUUID?: string;
        /** Filter leases by property owner UUID */
        ownerUUID?: string;
        /**
         * Number of items per page
         * @example 20
         */
        size?: number;
        /**
         * Page number (starting from 0)
         * @example 0
         */
        page?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<LeasesControllerFindAllData, void>({
        path: `/leases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves detailed information about a specific lease agreement by its UUID. Access is restricted based on user role.
     *
     * @tags Leases Management
     * @name LeasesControllerFindOne
     * @summary Get a lease by UUID
     * @request GET:/leases/{uuid}
     * @secure
     * @response `200` `LeasesControllerFindOneData` Returns the lease details with related property, tenant, and manager information.
     * @response `401` `void` Unauthorized access.
     * @response `403` `void` Forbidden. You do not have permission to view this lease.
     * @response `404` `void` Lease with the specified UUID was not found.
     */
    leasesControllerFindOne: (uuid: string, params: RequestParams = {}) =>
      this.request<LeasesControllerFindOneData, void>({
        path: `/leases/${uuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates an existing lease agreement with new information. All fields are optional. Access is restricted based on user role.
     *
     * @tags Leases Management
     * @name LeasesControllerUpdate
     * @summary Update a lease
     * @request PATCH:/leases/{uuid}
     * @secure
     * @response `200` `LeasesControllerUpdateData` The lease has been successfully updated.
     * @response `400` `void` Invalid input data.
     * @response `401` `void` Unauthorized access.
     * @response `403` `void` Forbidden. You do not have permission to update this lease.
     * @response `404` `void` Lease with the specified UUID was not found.
     */
    leasesControllerUpdate: (uuid: string, data: UpdateLeaseDto, params: RequestParams = {}) =>
      this.request<LeasesControllerUpdateData, void>({
        path: `/leases/${uuid}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Permanently removes a lease agreement from the system. Access is restricted based on user role.
     *
     * @tags Leases Management
     * @name LeasesControllerRemove
     * @summary Delete a lease
     * @request DELETE:/leases/{uuid}
     * @secure
     * @response `200` `LeasesControllerRemoveData` The lease has been successfully deleted.
     * @response `401` `void` Unauthorized access.
     * @response `403` `void` Forbidden. You do not have permission to delete this lease.
     * @response `404` `void` Lease with the specified UUID was not found.
     */
    leasesControllerRemove: (uuid: string, params: RequestParams = {}) =>
      this.request<LeasesControllerRemoveData, void>({
        path: `/leases/${uuid}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Updates the status of a lease agreement (active, completed, canceled, or pending). Access is restricted based on user role.
     *
     * @tags Leases Management
     * @name LeasesControllerUpdateStatus
     * @summary Update lease status
     * @request PATCH:/leases/{uuid}/status/{status}
     * @secure
     * @response `200` `LeasesControllerUpdateStatusData` The lease status has been successfully updated.
     * @response `400` `void` Invalid status value.
     * @response `401` `void` Unauthorized access.
     * @response `403` `void` Forbidden. You do not have permission to update this lease status.
     * @response `404` `void` Lease with the specified UUID was not found.
     */
    leasesControllerUpdateStatus: (
      uuid: string,
      status: "ACTIVE" | "COMPLETED" | "CANCELED" | "PENDING",
      params: RequestParams = {},
    ) =>
      this.request<LeasesControllerUpdateStatusData, void>({
        path: `/leases/${uuid}/status/${status}`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  systemSettings = {
    /**
     * @description Retrieves a list of all feature toggles with their complete details including enabled status, description, and display order
     *
     * @tags Feature Toggles
     * @name FeatureToggleControllerGetAllFeatureToggles
     * @summary Get all feature toggles
     * @request GET:/system-settings/feature-toggles
     * @secure
     * @response `200` `FeatureToggleControllerGetAllFeatureTogglesData` List of all feature toggles
     */
    featureToggleControllerGetAllFeatureToggles: (params: RequestParams = {}) =>
      this.request<FeatureToggleControllerGetAllFeatureTogglesData, any>({
        path: `/system-settings/feature-toggles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a simplified key-value object where keys are feature toggle keys and values are boolean states (enabled/disabled)
     *
     * @tags Feature Toggles
     * @name FeatureToggleControllerGetFeatureTogglesForFrontend
     * @summary Get all feature toggles as a key-value object for frontend
     * @request GET:/system-settings/feature-toggles/for-frontend
     * @secure
     * @response `200` `FeatureToggleControllerGetFeatureTogglesForFrontendData` Object with feature toggle keys and values
     */
    featureToggleControllerGetFeatureTogglesForFrontend: (params: RequestParams = {}) =>
      this.request<FeatureToggleControllerGetFeatureTogglesForFrontendData, any>({
        path: `/system-settings/feature-toggles/for-frontend`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Retrieves detailed information about a specific feature toggle
 *
 * @tags Feature Toggles
 * @name FeatureToggleControllerGetFeatureToggle
 * @summary Get a specific feature toggle by key
 * @request GET:/system-settings/feature-toggles/{key}
 * @secure
 * @response `200` `FeatureToggleControllerGetFeatureToggleData` Feature toggle found
 * @response `404` `{
  \** @example "Feature toggle with key enableUnknownFeature not found" *\
    message?: string,

}` Feature toggle not found
 */
    featureToggleControllerGetFeatureToggle: (key: string, params: RequestParams = {}) =>
      this.request<
        FeatureToggleControllerGetFeatureToggleData,
        {
          /** @example "Feature toggle with key enableUnknownFeature not found" */
          message?: string;
        }
      >({
        path: `/system-settings/feature-toggles/${key}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * @description Updates the enabled status of a feature toggle
 *
 * @tags Feature Toggles
 * @name FeatureToggleControllerUpdateFeatureToggle
 * @summary Update a feature toggle
 * @request PATCH:/system-settings/feature-toggles/{key}
 * @secure
 * @response `200` `FeatureToggleControllerUpdateFeatureToggleData` Feature toggle updated successfully
 * @response `404` `{
  \** @example "Feature toggle with key enableUnknownFeature not found" *\
    message?: string,

}` Feature toggle not found
 */
    featureToggleControllerUpdateFeatureToggle: (
      key: string,
      data: UpdateFeatureToggleDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FeatureToggleControllerUpdateFeatureToggleData,
        {
          /** @example "Feature toggle with key enableUnknownFeature not found" */
          message?: string;
        }
      >({
        path: `/system-settings/feature-toggles/${key}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
 * @description Updates the display order of a feature toggle in the UI
 *
 * @tags Feature Toggles
 * @name FeatureToggleControllerUpdateFeatureToggleOrder
 * @summary Update feature toggle order
 * @request PATCH:/system-settings/feature-toggles/{key}/order
 * @secure
 * @response `200` `FeatureToggleControllerUpdateFeatureToggleOrderData` Feature toggle order updated successfully
 * @response `404` `{
  \** @example "Feature toggle with key enableUnknownFeature not found" *\
    message?: string,

}` Feature toggle not found
 */
    featureToggleControllerUpdateFeatureToggleOrder: (
      key: string,
      data: UpdateFeatureToggleOrderDto,
      params: RequestParams = {},
    ) =>
      this.request<
        FeatureToggleControllerUpdateFeatureToggleOrderData,
        {
          /** @example "Feature toggle with key enableUnknownFeature not found" */
          message?: string;
        }
      >({
        path: `/system-settings/feature-toggles/${key}/order`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  featureToggles = {
    /**
     * @description Returns a simplified key-value object where keys are feature toggle keys and values are boolean states (enabled/disabled)
     *
     * @tags Public Feature Toggles
     * @name FeatureTogglePublicControllerGetFeatureTogglesForFrontend
     * @summary Get all feature toggles as a key-value object for frontend
     * @request GET:/feature-toggles
     * @response `200` `FeatureTogglePublicControllerGetFeatureTogglesForFrontendData` Object with feature toggle keys and values
     */
    featureTogglePublicControllerGetFeatureTogglesForFrontend: (params: RequestParams = {}) =>
      this.request<FeatureTogglePublicControllerGetFeatureTogglesForFrontendData, any>({
        path: `/feature-toggles`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
